import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import { fetchApp } from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditPointPage.css';
import { fetchPoint, putPoint } from '../../../store/points/actions';
import PointForm from '../../../components/openexplore/PointForm/PointForm';
import Mapbox from '../../../components/openexplore/Mapbox/Mapbox';
import { getTypes } from '../../../store/types/actions';
import { getCustomFields } from '../../../store/customfields/actions';
import CustomFieldService from '../../../services/customfield';
import { dispatchInfo } from '../../../store/infos/actions';
import { POINT_PAGE } from '../../../constants/routes';

const MapboxClient = require('mapbox');

export class EditPointPage extends React.Component {

    mapboxClient = new MapboxClient(
        'pk.eyJ1IjoiZHJ1c3kiLCJhIjoiY2owYjBlNmhrMDAwdzJxcDloMnJybHd1NyJ9.H256nOJ0yauBFXMZJ9972A');

    static propTypes = {
        app: PropTypes.object,
    };

    static defaultProps = {};

    state = {
        latlng: null,
        langModalOpened: false,
        address: null,
    };

    componentDidMount() {
        this.fetch();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.lang);
            this.props.getCustomFields(this.props.app.id);
        }

        if (this.props.point) {
            const latlnt = {
                lat: this.props.point.latitude,
                lng: this.props.point.longitude,
                shouldCenter: true,
            };
            this.setState({
                latlng: latlnt,
            });
            this.georeverseWithLatLng(latlnt);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            let url = POINT_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':pointId', this.props.point.id);
            this.props.history.push(url);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.point && (
            !this.state.latlng || this.props.point !== nextProps.point
        )) {
            const latlng = {
                lat: nextProps.point.latitude,
                lng: nextProps.point.longitude,
                shouldCenter: true,
            };

            this.georeverseWithLatLng(latlng);
            this.setState({
                latlng: latlng,
            });
        }

        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.lang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    // Fetch

    fetch(appId = null, pointId = null) {
        this.fetchApplication(appId);
        this.fetchPoint(appId, pointId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    fetchPoint(appId = null, pointId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const point = pointId || this.props.match.params.pointId;

            if (app && point) {
                this.props.fetchPoint(app, point, this.props.lang);
            }
        }
    }

    // Actions

    georeverseWithLatLng = (latlng) => {
        this.mapboxClient.geocodeReverse(
            {
                latitude: latlng.lat,
                longitude: latlng.lng,
            })
            .then(res => {
                if (res.entity.features
                    && res.entity.features.length > 0
                    && res.entity.features[0].place_name) {
                    this.initialAddresss = this.initialAddresss
                        ? this.initialAddresss
                        : res.entity.features[0].place_name;
                    this.setState({
                        address: res.entity.features[0].place_name,
                    });
                }
            })
            .catch(err => {
                //TODO: handle error
            });
    };

    handleMapClicked = (event) => {
        this.setState({
            latlng: event.latlng,
        });
        this.georeverseWithLatLng(event.latlng);
    };

    handleFormSubmit = async (formProps) => {
        await this.props.putPoint(this.props.app.id, formProps, this.props.lang);
    };

    handleLatChanged = (lat) => {
        let latlng = this.state.latlng;
        let shouldCenter = latlng !== null && latlng.lat !== lat;
        let stateChange;
        if (this.state.latlng !== undefined && this.state.latlng !== null) {
            stateChange = {
                ...this.state.latlng,
                lat: Number.parseFloat(lat),
                shouldCenter: shouldCenter,
            };
        } else {
            stateChange = {
                lat: Number.parseFloat(lat),
                lng: 0.0,
                shouldCenter: shouldCenter,
            };
        }
        this.setState({
            latlng: stateChange,
        });
    };

    handleLngChanged = (lng) => {
        let latlng = this.state.latlng;
        let shouldCenter = latlng !== null && latlng.lng !== lng;
        let stateChange;
        if (this.state.latlng !== undefined && this.state.latlng !== null) {
            stateChange = {
                ...this.state.latlng,
                lng: Number.parseFloat(lng),
                shouldCenter: shouldCenter,
            };
        } else {
            stateChange = {
                lat: 0.0,
                lng: Number.parseFloat(lng),
                shouldCenter: shouldCenter,
            };
        }
        this.setState({
            latlng: stateChange,
        });
    };

    handleFormReset = () => {
        if (this.props.point) {
            this.setState({
                latlng: {
                    lat: this.props.point.latitude,
                    lng: this.props.point.longitude,
                    shouldCenter: true,
                },
                address: this.initialAddresss,
            });
        }
    };

    handleAddressChanged = address => {
        this.setState({
            address: address,
        });
    };

    handleFindAddress = address => {
        this.mapboxClient.geocodeForward(address)
            .then(res => {
                if (res.entity.features
                    && res.entity.features.length > 0
                    && res.entity.features[0].center
                    && res.entity.features[0].center.length === 2) {
                    const center = res.entity.features[0].center;
                    this.setState({
                        latlng: {
                            lat: center[1],
                            lng: center[0],
                            shouldCenter: true,
                        },
                    });
                }
            })
            .catch(err => {
                console.log(err);
                this.props.dispatchInfo('Could not geocode address: ' + address);
            });
    };

    // Render

    renderMap() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <Paper>
                    <Subheader style={style.subHeader}>Map</Subheader>
                    <Mapbox
                        latlng={this.state.latlng}
                        onMapClicked={this.handleMapClicked}
                        scrollWheelZoom={false}
                        canShowDetail={false}
                        showPopups={false}
                        points={[]}
                        trails={[]}
                        style={styles.map}
                        mapStyle={this.props.mapStyle}
                    />
                </Paper>
            </div>
        );
    }

    renderForm() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.point.name}</Subheader>
                    <div style={style.paper}>
                        <PointForm
                            customFields={CustomFieldService.filter(this.props.customFields,
                                CustomFieldService.OPEN_EXPLORE_POINT,
                            )}
                            types={this.props.types}
                            onFormReset={this.handleFormReset}
                            onLatChanged={this.handleLatChanged}
                            onLngChanged={this.handleLngChanged}
                            onFindAddress={this.handleFindAddress}
                            onAddressChanged={this.handleAddressChanged}
                            onSubmit={this.handleFormSubmit}
                            latlng={this.state.latlng}
                            address={this.state.address}
                            initialValues={this.props.initialValues}
                            submitting={this.props.sending}
                            point={this.props.point}
                            enableReinitialize={true}
                        />
                    </div>
                    <div style={style.clear} />
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.point) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Point / Edit</h3>
                    <div className="row">
                        {this.renderMap()}
                        {this.renderForm()}
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending
            || state.points.pending
            || state.types.pending
            || state.customFields.pending,
        error: state.points.error || state.apps.error,
        point: state.points.currentPoint,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.points.sending,
        mapStyle: state.ui.mapStyle,
        types: state.types.content,
        customFields: state.customFields.content,
    };

    const point = state.points.currentPoint;
    if (point) {
        let initValues = { ...point };
        if (point.custom_fields) {
            point.custom_fields.forEach((customField) => {
                initValues[customField.id] = customField.value;
            });
        }
        props.initialValues = initValues;
    }

    return props;
}

export default connect(mapStateToProps, {
    getTypes,
    getCustomFields,
    putPoint,
    fetchApp,
    fetchPoint,
    dispatchInfo,
})(EditPointPage);



// WEBPACK FOOTER //
// src/containers/openexplore/EditPointPage/EditPointPage.js